import { useContext } from 'react';
import { SessionContext } from '../../providers/SessionProvider/SessionProvider';

export const useSession = () => useContext(SessionContext);
